import {
  CardElement as CardElementStripe,
  useElements,
} from '@stripe/react-stripe-js';

export const handleSubmitStripe = async({
  formData, 
  fields, 
  payment, 
  handleSubmitError, 
  product, 
  onSubmit
}: any) => {
  const elements = useElements();

        const valuesAdditionalFields = Object.keys(fields).reduce(
          (acc, key) => ({
            ...acc,
            [key]: fields[key].value,
          }),
          {}
        );

        let sessionRadar: any = {};
        try {
          const { radarSession } = await payment.createRadarSession();
          sessionRadar = radarSession;
        } catch (err) {

        }

        const cardElement = elements.getElement(CardElementStripe);
        const { error, paymentMethod } = await payment.createPaymentMethod({
          type: 'card',
          card: cardElement,
          billing_details: {
            ...valuesAdditionalFields,
          },
          radar_options: {
            session: sessionRadar?.id || ""
          }
        });

        if (error) {
          return handleSubmitError(error);
        }

        const { isIntroductory, trialDays, onetimePriceId } = product;
        formData.payment_method_id = paymentMethod?.id;
        formData.trial_period_days = trialDays;
        if (isIntroductory && onetimePriceId) {
          formData.introductory_price_id = onetimePriceId;
        }

        onSubmit(formData);
      }